export default __webpack_public_path__ + "static/media/El_mensaje_del_profeta_Ezequiel_para_hoy_1054_630_80.a209842e.jpg";